<div class="card-info">
  <span>Aktywne funkcje Twojej karty podarunkowej: <br> Sprawdzanie salda karty podarunkowej: <span
    class="green-color bold">aktywna</span><br>
    Płatność kartą w sklepie stacjonarnym: <span
      class="green-color bold">aktywna</span> <br>  Płatność kartą podarunkową w sklepie internetowym: <span
      *ngIf="!internetPaymentsActive" class="red-color bold">nieaktywna</span> <span *ngIf="internetPaymentsActive"
                                                                                     class="green-color bold">aktywna</span><br>
   <span *ngIf="!internetPaymentsActive" class="red-color"></span> </span>
</div>
<div class="row main-row" xmlns="http://www.w3.org/1999/html">
  <div class="col-sm-12 text-align-center">
    <div class="display-flex margin-on-phone">
      <div class="col-sm-3 offset-2 pull-right line-height no-margin-left-small-size balance-account-info">Stan konta:
      </div>
      <div
        class="col-sm-3 pull-left padding-left-55 balance-info white-space-no-wrap">{{getMainAmount(cardBalanceBody.Balance)}}
        ,<span>{{getRestAmount(cardBalanceBody.Balance)}}</span>
        <span class="padding-left-30">zł</span></div>
    </div>
    <div class="display-flex margin-on-phone">
      <div class="col-sm-3 offset-2 pull-right line-height no-margin-left-small-size balance-account-info"><span>Data ważności:</span>
      </div>
      <div class="col-sm-4 pull-left padding-left-55 min-width-dates">
        od <span class="balance-info">{{cardBalanceBody.DateFrom}} r. </span><br *ngIf="smallScreen"> do <span
        class="balance-info">{{cardBalanceBody.DateTo}} r.</span>
      </div>
    </div>
    <div class="display-flex margin-on-phone">
      <div class="col-sm-3 offset-2 pull-right line-height no-margin-left-small-size balance-account-info">Numer
        karty:
      </div>
      <div class="col-sm-4 pull-left padding-left-55 balance-info white-space-no-wrap">
        {{cardBalanceBody.CardNumber}}
      </div>
    </div>
  </div>
  <div class="col-sm-12 transaction-history">
    <h4>Historia transakcji</h4>
    <table class="history-table table no-margin-left-small-size">
      <thead>
      <tr>
        <th class="col">Typ transakcji</th>
        <th class="col">Data transakcji</th>
        <th class="col">Kwota transakcji</th>
        <th class="col">Stan konta po transakcji</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let record of cardHistoryBody.TransactionList">
        <th
          [ngClass]="{'red-color': !checkTransactionType(record.TransType), 'green-color': checkTransactionType(record.TransType)}"
          scope="row">{{record.TransType}}</th>
        <th><span style="white-space: nowrap">{{formatDate(record.TransactionDateTime)}}</span></th>
        <th class="amount-record">{{getMainAmount(record.Amount)}},<span>{{getRestAmount(record.Amount)}}</span>
          <span class="currency-info">zł</span></th>
        <th class="balance-record">{{getMainAmount(record.Balance)}}
          ,<span>{{getRestAmount(record.Balance)}}</span> <span class="currency-info">zł</span></th>
      </tr>
      </tbody>
    </table>
  </div>
</div>
<!--<div style="height: 100px">-->
<!---->
<!--</div>-->
